import { BaseAuditModel, IBaseAuditModel } from '@d-models/other/http.model';

type IBaseEventLogModel = IBaseAuditModel<{
  recordId: string;
  userId: string;
  userName: string;
  event: string;
  module: string;
  appPlatform: string;
  browser: string;
  browserVersion: string;
  mobileModel: string;
  mobile_OS_Version: string;
  clientIMEI: string;
  clientHostName: string;
  clientIP: string;
  clientPort: string;
  clientLatitude: string;
  clientLongitude: string;
}>;

interface IEventLogModel extends IBaseEventLogModel {
  id: string;
}

export class EventLogModel
  extends BaseAuditModel<IEventLogModel>
  implements IEventLogModel
{
  constructor(data: IEventLogModel) {
    super(data);
  }
  id: string;
  recordId: string;
  userId: string;
  userName: string;
  event: string;
  module: string;
  appPlatform: string;
  browser: string;
  browserVersion: string;
  mobileModel: string;
  mobile_OS_Version: string;
  clientIMEI: string;
  clientHostName: string;
  clientIP: string;
  clientPort: string;
  clientLatitude: string;
  clientLongitude: string;

  static createPayload(
    data: Omit<IBaseEventLogModel, keyof IBaseAuditModel<{}>>,
  ): Omit<IBaseEventLogModel, keyof IBaseAuditModel<{}>> {
    return data;
  }
}

export class ModuleTableResModel {
  moduleTables: IModuleTable[];

  constructor(data: IModuleTableRes) {
    this.moduleTables = data.moduleTables.map((val) => ({
      moduleName: val.moduleName,
      tablesNames: val.tablesNames,
    }));
  }
}

export interface IModuleTableRes {
  moduleTables: IModuleTable[];
}

export interface IModuleTable {
  moduleName: string;
  tablesNames: string[];
}
